import { CommunicationMethod } from "./siteFuelPointDTO";

export interface SiteFccDTO {
  code?: string;
  siteCode: string;
  description: string;
  detailedDescription?: object;
  deviceTypeCode?: string;
  fccType?: FccType;
  fccTypeCode?: string;
  additionalData?: AdditionalData;
  enabled: boolean;
}

export interface FccType {
  code: string;
  description: string;
  detailedDescription?: object;
}

export interface AdditionalData {
  petrotecLegacyConfig: PetrotecLegacyConfig;
  forecourtEventClientIp: string;
  forecourtEventClientPort: string;
}

export interface PetrotecLegacyConfig {
  commCfg?: FccCommunicationCfg;
  pmpCfg?: FccPmpCfg;
  unitsCfg?: FccUnitsCfg;
}

interface FccCommunicationCfg {
  fccAddress: string;
  fccPort: string;
  configurationPort: string;
  clientAddress: string;
  clientPort: string;
}

interface FccPmpCfg {
  pmpType: string;
  pmpTypeProfile: string;
  amountDp?: string;
  volumeDp?: string;
  unitPriceDp?: string;
  presetVolumeDp?: string;
  presetAmountDp?: string;
  minPresetAmount?: string;
  minPresetVolume?: string;
}

interface FccUnitsCfg {
  amountDp: string;
  volumeDp: string;
  unitPriceDp: string;
}

export enum FccTypeCode {
  PETROTEC = "PETROTEC",
  IFSF = "IFSF",
  NEURON_1_5 = "NEURON_1_5",
  NEURON_2_0 = "NEURON_2_0"
}

export const FccPmpCfgProfiles = [
  {
    id: "1",
    code: "PUMP_KA",
    description: "KoppensKA/PetrotecKA",
  },
  {
    id: "2",
    code: "PUMP_HDX",
    description: "PetrotecHDX/Gilbarco",
    profile: [
      {
        id: "0",
        description: "5787 bps even",
        baudRate: 5787,
      },
      {
        id: "1",
        description: "4800 bps even",
        baudRate: 4800,
      },
      {
        id: "2",
        description: "9600 bps odd",
        baudRate: 9600,
      },
    ],
  },
  {
    id: "3",
    description: "Wayne",
  },
  {
    id: "4",
    description: "Tokheim",
  },
  {
    id: "5",
    code: "PUMP_DOMS",
    description: "DOMS",
  },
  {
    id: "6",
    description: "Tatsuno",
  },
  {
    id: "7",
    description: "IFSF",
  },
  {
    id: "8",
    code: "PUMP_HIM",
    description: "HIM",
    profile: [
      {
        id: "0",
        description: "UNCONFIGURED",
        baudRate: 5787,
      },
      {
        id: "11",
        description: "LITRES RETAIL 30S 1M",
        baudRate: 5787,
      },
      {
        id: "12",
        description: "LITRES RETAIL 1M",
        baudRate: 5787,
      },
      {
        id: "13",
        description: "LITRES FLEET 1M",
        baudRate: 5787,
      },
      {
        id: "14",
        description: "GALLONS RETAIL 30S 1M",
        baudRate: 5787,
      },
      {
        id: "15",
        description: "GALLONS RETAIL 1M",
        baudRate: 5787,
      },
      {
        id: "16",
        description: "GALLONS FLEET 1M",
        baudRate: 5787,
      },
      {
        id: "21",
        description: "LITRES RETAIL 30S 2M",
        baudRate: 5787,
      },
      {
        id: "22",
        description: "LITRES RETAIL 2M",
        baudRate: 5787,
      },
      {
        id: "23",
        description: "LITRES FLEET 2M",
        baudRate: 5787,
      },
      {
        id: "24",
        description: "GALLONS RETAIL 30S 2M",
        baudRate: 5787,
      },
      {
        id: "25",
        description: "GALLONS RETAIL 2M",
        baudRate: 5787,
      },
      {
        id: "26",
        description: "GALLONS FLEET 2M",
        baudRate: 5787,
      },
      {
        id: "99",
        description: "LOCALLY DEF. CUSTOM",
        baudRate: 5787,
      },
    ]
  },
];

export interface SiteDeviceFccDTO {
  siteCode?: string;
  code?: string;
  serialNumber?: string;
  description?: string;
  enabled?: boolean;
  protocolTypeCode?: string;
  communicationMethodTypeCode?: string;
  communicationMethodData?: CommunicationMethod;
  serviceModeCode?: string;
  serviceMode?: ServiceFuellingModes;
  fuellingModeCode?: string;
  fuellingMode?: ServiceFuellingModes;
  connectedFuelPoint?: string[];
  connectedPriceSings?: string[];
  connectedTLGs?: string[];
  connectedPOs?: string[];
  additionalData?: AdditionalData;
}

interface ServiceFuellingModes {
  code: string;
  description: string;
}
